"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.numberTransfer = void 0;
var constant_1 = require("../constant");
var language_format_utils_1 = require("../language/language-format-utils");
// TODO: 暂时从原函数中引入, 后续替换
var Common_1 = require("../../utils/Common");
/**
 * 根据解析出的数字展示类型计算对应的转换后的语言
 * @param tokenizedList 分词后得到的数组
 * @param numberLanguageType 解析到的数值的语言类型
 */
function numberTransfer(tokenizedList, numberLanguageType) {
    // 转换数字大小写
    tokenizedList = tokenizedList.filter(function (token, index) {
        if (token.type === constant_1.TokenType.Text && Common_1.isNumeric(token.value)) {
            // 预定义转换选项
            var transferOptions = undefined;
            // 判断数字是否位于年月日格式下
            if (index + 1 < tokenizedList.length) {
                switch (tokenizedList[index + 1].value) {
                    case '年':
                        transferOptions = { unit: false, fill: true };
                        break;
                    case '月':
                    case '日':
                    case '分':
                        transferOptions = { unit: true, fill: true };
                        break;
                    case '时':
                        transferOptions = { unit: true, fill: true };
                        break;
                }
            }
            // 其余情况常规数字转化开启 showTenOne, 对齐 excel
            transferOptions = transferOptions || { unit: true, fill: false, showTenOne: true };
            // 进行转换
            token.value = language_format_utils_1.convertNumToChinese(String(token.value), numberLanguageType, transferOptions);
        }
        return true;
    });
}
exports.numberTransfer = numberTransfer;
//# sourceMappingURL=number-transfer.js.map